import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ZoomOutFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ZoomOutFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="m22.53 20.41-4.73-4.73a8.939 8.939 0 0 0 1.67-5.21 9 9 0 1 0-9 9c1.94 0 3.74-.62 5.21-1.67l4.73 4.73 2.12-2.12Zm-12.06-3.94c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6Z" />
          <path d="M12.97 8.97h-5v3h5v-3Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default ZoomOutFilled;